import { z } from 'zod';
import { requiredString } from '../helpers';
export const Calendly_Create_Meeting_1_ConfigValidator = z.object({
    calendlyConnection: requiredString('Calendly connection is required'),
    eventTypeUri: requiredString('Event type is required'),
    startTime: requiredString('Start time is required'),
    inviteeName: requiredString('Invitee name is required'),
    inviteeEmail: requiredString('Invitee email is required'),
    inviteeTimezone: requiredString('Invitee timezone is required'),
    locationKind: z
        .enum(['none', 'physical', 'zoom', 'google_meet', 'microsoft_teams', 'phone', 'custom'])
        .nullable()
        .optional(),
    locationLocation: z.string().optional()
});
//# sourceMappingURL=calendly-create-meeting-1.js.map